import { surveyLocalization } from "survey-core";

export var turkishSurveyStrings = {
  pagePrevText: "Geri",
  pageNextText: "İleri",
  completeText: "Anketi Tamamla",
  previewText: "Ön izleme",
  editText: "Düzenle",
  startSurveyText: "Başlat",
  otherItemText: "Diğer (açıklayınız)",
  noneItemText: "Yok",
  selectAllItemText: "Hepsini seç",
  progressText: "Sayfa {0} / {1}",
  panelDynamicProgressText: "Kayıt {0} / {1}",
  questionsProgressText: "Soruları cevapladı {0} / {1}",
  emptySurvey: "Ankette görüntülenecek sayfa ya da soru mevcut değil.",
  completingSurvey: "Anketimizi tamamladığınız için teşekkür ederiz.",
  completingSurveyBefore:
    "Kayıtlarımız, bu anketi zaten tamamladığınızı gösteriyor.",
  loadingSurvey: "Anket sunucudan yükleniyor ...",
  placeholder: "Seçiniz ...",
  value: "değer",
  requiredError: "Lütfen soruya cevap veriniz",
  requiredErrorInPanel: "Lütfen en az bir soruyu yanıtlayın.",
  requiredInAllRowsError: "Lütfen tüm satırlardaki soruları cevaplayınız.",
  numericError: "Girilen değer numerik olmalıdır",
  textMinLength: "En az {0} sembol giriniz.",
  textMaxLength: "Lütfen {0} karakterden az girin.",
  textMinMaxLength: "Lütfen {0} ’den fazla ve {1} ’den az karakter girin.",
  minRowCountError: "Lütfen en az {0} satırı doldurun.",
  minSelectError: "Lütfen en az {0} seçeneği seçiniz.",
  maxSelectError: "Lütfen {0} adetten fazla seçmeyiniz.",
  numericMinMax:
    "The '{0}' should be equal or more than {1} and equal or less than {2}",
  numericMin: "'{0}' değeri {1} değerine eşit veya büyük olmalıdır",
  numericMax: "'{0}' değeri {1} değerine eşit ya da küçük olmalıdır.",
  invalidEmail: "Lütfen geçerli bir eposta adresi giriniz.",
  invalidExpression: "İfade: {0} 'true' döndürmelidir.",
  urlRequestError: "Talebi şu hatayı döndü '{0}'. {1}",
  urlGetChoicesError:
    "Talep herhangi bir veri dönmedi ya da 'path' özelliği hatalı.",
  exceedMaxSize: "Dosya boyutu {0} değerini geçemez.",
  otherRequiredError: "Lütfen diğer değerleri giriniz.",
  uploadingFile:
    "Dosyanız yükleniyor. LÜtfen birkaç saniye bekleyin ve tekrar deneyin.",
  loadingFile: "Yükleniyor...",
  chooseFile: "Dosyaları seçin ...",
  noFileChosen: "Dosya seçili değil",
  confirmDelete: "Kaydı silmek istiyor musunuz?",
  keyDuplicationError: "Bu değer benzersiz olmalıdır.",
  addColumn: "Sütun ekleyin",
  addRow: "Satır Ekle",
  removeRow: "Kaldır",
  addPanel: "Yeni ekle",
  removePanel: "Kaldırmak",
  choices_Item: "eşya",
  matrix_column: "Sütun",
  matrix_row: "Kürek çekmek",
  savingData: "Sonuçlar sunucuya kaydediliyor ...",
  savingDataError: "Bir hata oluştu ve sonuçları kaydedemedik.",
  savingDataSuccess: "Sonuçlar başarıyla kaydedildi!",
  saveAgainButton: "Tekrar deneyin",
  timerMin: "min",
  timerSec: "saniye",
  timerSpentAll: "Bu sayfada {0} ve toplamda {1} harcadınız.",
  timerSpentPage: "Bu sayfaya {0} harcadınız.",
  timerSpentSurvey: "Toplamda {0} harcadınız.",
  timerLimitAll:
    "Bu sayfaya {0} / {1} ve toplamda {2} / {3} harcadınız.",
  timerLimitPage: "Bu sayfaya {0} / {1} harcadınız.",
  timerLimitSurvey: "Toplamda {0} / {1} harcadınız.",
  cleanCaption: "Temiz",
  clearCaption: "Açık",
  chooseFileCaption: "Dosya seçin",
  removeFileCaption: "Bu dosyayı kaldır",
  booleanCheckedLabel: "Evet",
  booleanUncheckedLabel: "Hayır",
  confirmRemoveFile: "Bu dosyayı kaldırmak istediğinizden emin misiniz: {0}?",
  confirmRemoveAllFiles: "Tüm dosyaları kaldırmak istediğinizden emin misiniz?",
  questionTitlePatternText: "Soru başlığı",
};

surveyLocalization.locales["tr"] = turkishSurveyStrings;
surveyLocalization.localeNames["tr"] = "türkçe";
